<template>
  <div class="btn-group-sm">
    <button @click="modificar" type="button" class="btn btn-sm btn-primary">
      Modificar
    </button>
    <button @click="empresas" type="button" class="btn btn-sm btn-success">
      Empresas
      <span type="button" class="badge badge-light">{{
        params.data.empresas_count
      }}</span>
    </button>
    <button type="button" class="btn btn-sm btn-warning" @click="contratos">
      Contratos
      <span type="button" class="badge badge-light">{{
        params.data.contratos_count
      }}</span>
    </button>
    <button
      @click="goToCuentaDeCliente"
      type="button"
      class="btn btn-sm btn-primary"
    >
      Estado de cuenta
    </button>
    <button
      @click="goToFacturasYNotasDeCredito"
      type="button"
      class="btn btn-sm btn-info"
    >
      Facturas y N/C
    </button>

    <a
      :href="link"
      target="_blank"
      type="button"
      class="btn btn-sm btn-primary"
    >
      App
    </a>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "ClientesTablaActions",
  computed: {
    link() {
      if (!this.params || !this.params.data) {
        this.$msgBoxOk("Error: el usuario no está definido");
        return;
      }
      const baseUrl = "https://mobilequest.com.ar/home_sin_control.php";
      const usuario = this.params.data.usuario || "";
      const clave = this.params.data.clave || "";

      const codificarCaracteresEspeciales = (str) => {
        return btoa(
          encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) =>
            String.fromCharCode("0x" + p1),
          ),
        );
      };

      const usuarioCodificado = encodeURIComponent(
        codificarCaracteresEspeciales(usuario),
      );
      const claveCodificada = encodeURIComponent(
        codificarCaracteresEspeciales(clave),
      );

      const url = `${baseUrl}?usuario=${usuarioCodificado}&clave=${claveCodificada}&auto=1`;

      return url;
    },
  },
  methods: {
    modificar() {
      this.$router.push("/admin/clientes/" + this.params.data.id_cliente);
    },
    empresas() {
      this.$router.push(
        `/admin/clientes/${this.params.data.id_cliente}/empresas`,
      );
    },
    contratos() {
      this.$router.push(
        `/admin/clientes/${this.params.data.id_cliente}/contratos`,
      );
    },
    goToCuentaDeCliente() {
      this.$router.push(
        `/admin/clientes/${this.params.data.id_cliente}/cuenta`,
      );
    },
    goToFacturasYNotasDeCredito() {
      this.$router.push(
        `/admin/clientes/${this.params.data.id_cliente}/facturas-y-notas-de-credito`,
      );
    },
  },
});
</script>

<style scoped></style>
